import {
  CancellationActionEnum,
  ICancellationReason,
  IUserCancellation,
} from "@smartrr/shared/entities/CancellationRelationship";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { useCallback, useState } from "react";

import { saveUserCancellation } from "@customer-app/state/actionCreators/retention";
import { useSmartrrCustomerDispatch } from "@customer-app/state/typedCustomerReduxHooks";

export const useCancellationReason = (purchaseState: IPurchaseState) => {
  const dispatch = useSmartrrCustomerDispatch();
  const [cancellationReason, setCancellationReason] = useState<ICancellationReason | undefined>();
  const [userCancellationReasonText, setUserCancellationReasonText] = useState<string>("");
  const saveUserCancellationData = useCallback(
    (cancel?: boolean) => {
      const userCancellation: IUserCancellation = {
        reasonText: userCancellationReasonText || "",
        action: cancel ? CancellationActionEnum.CANCEL : cancellationReason!.action,
        stId: purchaseState.id,
        cancellationReasonId: cancellationReason!.id,
      };
      dispatch(saveUserCancellation(userCancellation));
    },
    [cancellationReason, purchaseState, userCancellationReasonText, dispatch]
  );

  return {
    cancellationReason,
    setCancellationReason,
    userCancellationReasonText,
    setUserCancellationReasonText,
    saveUserCancellationData,
  };
};
